import DataAccess from './constants';
import API from './API';

const path = 'validation';

export const apiBookingIdsValidation = (params) => {

    let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);
    let url = "?Type=MultipleBookings&SearchString=" + params.bookingIDList;


    if (params.lastName && params.lastName != '') {  //@CardOrMemberNo - LastName
        url += '&CardOrMemberNo=' + params.lastName;

    }

    if (params.email && params.email != '') {   //@@GiftcardNo - Email
        url += '&GiftcardNo=' + params.email;
    }

    return api.postData(path + url, []);
}